/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';

import {ApiConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {
  AdnHttpSender,
  createAdnHttpResource,
  createAdnHttpResourceSender
} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class SegmentWithTargetingService {
  private readonly send: AdnHttpSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  postTargeting(targeting: any, params: any): Promise<any> {
    return this.send({
      method: 'POST',
      url: ApiConfig.obtain().getVersionedUri(['segments', 'withtargeting']),
      params: _.assign({}, {format: 'json', concise: true}, params || {}),
      body: targeting
    });
  }
}

/** Angular DI token for the Segment HTTP resource (factory product). */
export class SegmentResource {
}

export function createSegmentResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const Segment = createAdnHttpResource(
    createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler),
    'segments',
    () => localUserProfile
  );

  Segment.ogQuery = Segment.query;
  Segment.query = function(a1: any, a2: any, a3: any) {
    const params: any = {};
    if (localUserProfile.getCurrentApp() !== 'ADVERTISING') {
      params.dataSource = 'ADNUNTIUS';
    }
    return Segment.ogQuery(_.merge({}, a1, params), a2, a3);
  };

  return Segment;
}

export const segmentResourceProvider = {
  provide: SegmentResource,
  useFactory: createSegmentResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};
